/**
 * Colour mapping for candidate stage groups (AC6 — colour-coded status badge).
 * Returns Tailwind classes for a badge (background, text, border, dot).
 */

export interface StageColor {
  bg: string
  text: string
  border: string
  dot: string
}

const STAGE_COLORS: Record<string, StageColor> = {
  SHORTLISTED:         { bg: 'bg-blue-50',   text: 'text-blue-700',   border: 'border-blue-200',   dot: 'bg-blue-500' },
  TECHNICAL_INTERVIEW: { bg: 'bg-violet-50', text: 'text-violet-700', border: 'border-violet-200', dot: 'bg-violet-500' },
  HR:                  { bg: 'bg-amber-50',  text: 'text-amber-700',  border: 'border-amber-200',  dot: 'bg-amber-500' },
  SELECTION_OFFER:     { bg: 'bg-green-50',  text: 'text-green-700',  border: 'border-green-200',  dot: 'bg-green-500' },
  BGV_JOINING:         { bg: 'bg-teal-50',   text: 'text-teal-700',   border: 'border-teal-200',   dot: 'bg-teal-500' },
  CLOSURE:             { bg: 'bg-rose-50',   text: 'text-rose-700',   border: 'border-rose-200',   dot: 'bg-rose-500' },
}

const NEUTRAL: StageColor = {
  bg: 'bg-gray-50', text: 'text-gray-600', border: 'border-gray-200', dot: 'bg-gray-400',
}

/** Colour classes for a stage code (falls back to neutral for unknown/"Not Set"). */
export function getStageColor(stageCode?: string | null): StageColor {
  if (!stageCode) return NEUTRAL
  return STAGE_COLORS[stageCode] ?? NEUTRAL
}
